/** Public product facts. Keep wording and structured data in sync. */
export const productFacts = {
  name: 'Chat.co',
  url: 'https://chat.co',
  description:
    'Chat.co turns business documents and websites into AI agents with source citations for customer support, private team knowledge, and specialist research.',
  trial:
    'Start a 14-day free trial with no credit card required. There is no permanent free plan. Choose a paid plan to continue after the trial.',
  pricingUrl: '/#pricing-brand',
  reviewedAt: '2026-09-24',
  socialUrls: [
    'https://x.com/chatdotco',
    'https://www.linkedin.com/company/chatco',
    'https://www.instagram.com/chatdotco/',
    'https://www.facebook.com/profile.php?id=61588497410599',
  ],
};

export const productCapabilities = [
  {
    name: 'Knowledge sources',
    detail:
      'Upload documents, crawl approved website pages, or add text and curated Q&A. Supported connectors include Google Drive, OneDrive, SharePoint, and Notion. Setup and permissions depend on the connector.',
    href: '/docs/knowledge-upload',
  },
  {
    name: 'Answers and citations',
    detail:
      'Agents retrieve information from configured sources and can provide references for review. Citations help verify an answer; they do not guarantee accuracy. Source coverage and agent configuration affect the result.',
    href: '/docs/citation-quality',
  },
  {
    name: 'Public and private deployment',
    detail:
      'Deploy through a website embed, iframe, share link, or QR code. Private agents require authenticated access. Availability and quotas depend on the selected plan or add-ons.',
    href: '/docs/website-integration',
  },
  {
    name: 'Model choice',
    detail:
      'Choose from the model catalog available to your plan. Models, credit costs, and availability can change; consult the current plan details rather than assuming every model is included.',
    href: '/#pricing-brand',
  },
  {
    name: 'API and MCP',
    detail:
      'Documented API and MCP access support integrations with applications and compatible AI clients. They require account credentials and appropriate permissions.',
    href: '/docs/api-vs-mcp',
  },
  {
    name: 'Certification status',
    detail:
      'SA CYBER LLC’s information security management system supporting Chat.co is certified to ISO/IEC 27001:2022, certificate GCAI-ISMS-LM73, valid through August 28, 2029. The SOC 2 Type II audit is in progress; Chat.co does not claim SOC 2 certification.',
    href: '/docs/security-compliance',
  },
  {
    name: 'Security and data handling',
    detail:
      'Encryption at rest and in transit, authenticated access, and role-based administration protect knowledge. Hosting, retention, model-provider terms, SSO, and contractual requirements must be evaluated for the selected deployment.',
    href: '/privacy',
  },
];
